import { TraceXInterceptor } from '@trace-x/trace-x-generator';
import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output, Renderer2,
  SimpleChanges
} from '@angular/core';
import {HotelCriteriaComponent} from '../hotel-criteria/hotel-criteria.component';
import {DataServiceHandler} from '@tc-core/service/service-handlers';
import {
  ConfigService,
  DataShareService, SurfAuthorizationService,
  SurfCalendarStartDateService,
  SurfCriteriaUtil, SurfGeoSpatialSearchGoogleService,
  SurfTravellerEarliestDepartureDateService
} from '@surf/surf-components-core';
import {ConfigLoader, DataStore} from '@tc-core/util/framework';
import {TravellerInterest} from "@surf/surf-traveller-interests";
import { HelperService } from '../service/helper.service';
import {HttpClient} from "@angular/common/http";
@Component({
  selector: 'surf-hotel-criteria-dp',
  templateUrl: './hotel-criteria-dp.component.html'
})
export class HotelCriteriaDpComponent extends HotelCriteriaComponent implements OnInit,OnChanges {

  @Input() selectComp = false;              /*needed for dp criteria*/
  @Output() itemRemoved: EventEmitter<any> = new EventEmitter<any>();

  isSelected = false;
  datePickerLabel = 'CHECK-IN & CHECK-OUT DATES*';
  starRatingList=['Day,Night'];

  enableTravellerInterestsModal = false;
  holidayTypes = [];
  addChildToBodyIdMap = new Map<string, boolean>();

  constructor(protected dataServiceHandler: DataServiceHandler,
              protected commonService: DataShareService,
              protected dataStore: DataStore,
              protected configLoader: ConfigLoader,
              protected configService: ConfigService,
              public surfCriteriaUtil: SurfCriteriaUtil,
              protected surfGeoSpatialSearchGoogleService: SurfGeoSpatialSearchGoogleService,
              private renderer: Renderer2,
              protected travellerEarliestDepartureDateService: SurfTravellerEarliestDepartureDateService,
              protected surfAuthorizationService: SurfAuthorizationService,
              protected surfCalendarStartDateService: SurfCalendarStartDateService,
              public helperService: HelperService, protected http: HttpClient) {
    super(dataServiceHandler, commonService, dataStore, configLoader, configService, surfCriteriaUtil, surfGeoSpatialSearchGoogleService,
      travellerEarliestDepartureDateService, surfAuthorizationService, surfCalendarStartDateService, helperService, http);
  }

  ngOnChanges(changes: SimpleChanges): void {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.ngOnChanges');
    super.ngOnChanges(changes);

    /*if this component is added to the dp criteria panel initially, then it should be selected = true*/
    if (changes.selectComp) {
      this.isSelected = changes.selectComp.currentValue;
    }
  }

  public selectComponent() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.selectComponent');
    this.isSelected = true;
  }

  public deselectComponent() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.deselectComponent');
    this.isSelected = false;
  }

  getCalendarStartDate() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.getCalendarStartDate');
    if (this.dpEnableDateChanged) {
      this.surfCalendarStartDateService.updateMinDate(this.dpCalEnableDate, 'HTL');
      return this.dpCalEnableDate;
    }
    this.surfCalendarStartDateService.updateMinDate(this.calendarMinDate, 'HTL');
    return this.calendarMinDate;
  }

  removeItem() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.removeItem');
    if (!this.isRefine && !this.isDPSearch) {
      this.commonService.updateComponentCriteria(null, 'HTL');
    }
    this.itemRemoved.emit(this.index);
  }

  moveToDP(position: string) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.moveToDP');
    if (!this.isRefine) {          /*TODO: Implemented for refine*/
      if (!this.isDPSearch) {                     /*Move to DP search panel if only; was in the component flow previously*/
        this.msg = 'DP_Switch~HTL~' + position;
        // this.commonService.changeMessage(msg);
        // sessionStorage.setItem('partialCriteria', JSON.stringify(this.hotelCriteria));
      }
    }
  }

  passengerSplitChange(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.passengerSplitChange');
    if (event && event.length === this.paxSplitArray.length) {
      this.isPaxSplitChanged.emit(false);
    } else {
      this.isPaxSplitChanged.emit(true);
    }
  }

  /**
   * enable passenger split dropdown
   */
  enablePaxSplitDropdown() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.enablePaxSplitDropdown');
    this.enablePaxSplit = true;
  }

  addParentToLocationGroup(locationGroup, city) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.addParentToLocationGroup');
    let parent = [];
    if(city){
      parent.push({code: city.code, name: city.name, type: city.type});  /*add city*/
    }
    if(city.parent && city.parent[0]){
      parent.push({code: city.parent[0].code, name: city.parent[0].name, type: city.parent[0].type});  /*add country*/
    }
    locationGroup.parent = parent;
    return locationGroup;
  }

  getCountry(city): string {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.getCountry');
    let parentName = null;
    if (city.parent && city.parent.length > 0) {
      city.parent.forEach(p => {
        if (p.type == 20) {
          parentName = p.name;
        }
      });
    }
    return parentName;
  }

  rearrangeModals(id) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.rearrangeModals');
    if (document.getElementById(id)) {
      document.body.appendChild(document.getElementById(id));
      this.addChildToBodyIdMap.set(id, true);
    }
  }

  /**
   * open surf-traveller-interests modal on add/update action
   */
  onAddOrUpdateTravellerInterests() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.onAddOrUpdateTravellerInterests');
    this.renderer.addClass(document.body, 'u-unscrollable');
    this.enableTravellerInterestsModal = true;
    this.rearrangeModals('traveller-interests-modal');
  }

  /**
   * get selected Traveller Interests emitted from the surf-traveller-interests
   * @param event - list of selected Traveller Interests
   */
  getSelectedTravellerInterests(event: TravellerInterest[]) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.getSelectedTravellerInterests');
    if (event) {
      this.selectedTravellerInterests = event;
    }
  }

  /**
   * receive modal close emit and close modal
   * @param event - boolean false
   */
  closeTravellerInterestModal(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.closeTravellerInterestModal');
    this.renderer.removeClass(document.body, 'u-unscrollable');
    this.enableTravellerInterestsModal = event;
  }

  /**
   * handle and display geo location auto complete error list
   * @param errorList - error list
   */
  handleGeoLocationErrors(errorList: Array<string>) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.handleGeoLocationErrors');
    this.geoLocationAutoCompleteErrors = errorList;
    if (this.geoLocationAutoCompleteErrors && this.geoLocationAutoCompleteErrors.length > 0 && this.GEO_HTL_AUTO_SWITCH_ENABLED) {
      this.switchGeoLocationSearch();
    }
  }

  /**
   * switch geo location search to normal search
   */
  switchGeoLocationSearch() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.switchGeoLocationSearch');
    this.isGeoSearchSwitched = true;
    this.activeToaster = true;
    this.departureUrl = (this.STATIC_DATA_URL_BASE + '?dataTypes=' + this.getStaticDataTypes() +
      '&userInput=[UI]&aggrLevel=COUNTRY&locale=en&matchType=CODE~NAME&expand=all&resultCount=' + this.STATIC_DATA_FETCH_SIZE);
    setTimeout(() => {
      this.switchNormalSearch();
    }, this.GEO_HTL_AUTO_SWITCH_RETRY_TIME * 1000);
  }

  /**
   * switch normal search to geo location search
   */
  switchNormalSearch() {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.switchNormalSearch');
    this.isGeoSearchSwitched = false;
    this.activeToaster = false;
    this.geoLocationAutoCompleteErrors = [];
    this.departureUrl = (this.STATIC_DATA_URL_BASE + '?dataTypes=' + this.getStaticDataTypes() +
      '&userInput=[UI]&aggrLevel=COUNTRY&locale=en&matchType=CODE~NAME&expand=all&resultCount=' + this.STATIC_DATA_FETCH_SIZE);
  }

  onclickActionItem(event) {
    TraceXInterceptor.interceptTrace('dashboard/projects/surf-hotel-criteria/src/lib/hotel-criteria-dp/hotel-criteria-dp.component.ts.HotelCriteriaDpComponent.onclickActionItem');
    if (event && event === 'cancel') {
      this.activeToaster = false;
    }
  }
}
